import { Company } from '@modules-deprecated/app/companies/types'
import { getCompanyName } from '@modules-deprecated/app/companies/utils/getCompanyName'

export const getDisplayValue = (item?: Partial<Company>, customDisplayValueFn?: (item: Partial<Company>) => string) => {
  if (!item) {
    return null
  }

  if (customDisplayValueFn) {
    return customDisplayValueFn(item)
  }

  return getCompanyName(item)
}
